import React, { useState } from "react";
import "./styles.css";
import { Grid, Typography, TextField, Link } from "@mui/material";
import DialogComp from "../../components/Dialog-Popup";
import Button from "../../components/Button";
import loginimage from "../../assets/loginbackground.jpg";
import image1 from "../../assets/loginmiddle1.png";
import image2 from "../../assets/logindotted.png";
import { useNavigate } from "react-router-dom";
import axios from "axios";

function Login() {
  const [isHidden, setHidden] = useState(true);
  const [openPopup, setOpenPopup] = useState(false);
  const [popuptitle, SetPopupTitle] = useState("");
  const [otp, setOtp] = useState("");
  const [popupContent, SetPopupContent] = useState("");
  const [buttonArr, setButtonArr] = useState([]);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  const handleLogin = async () => {
    try {
      const response = await axios.post("https://usermanagementsystem-497524552274.us-central1.run.app/auth/login", { email, password });
      const { token } = response.data;
      if (token) {
        localStorage.setItem("authToken", token);
        setHidden(false);
        setOpenPopup(true);
        SetPopupTitle("Logged in successfully");
        SetPopupContent("You've logged in successfully. Please fill some details to get started.");
        setButtonArr([{ id: "1", value: "PROCEED", color: "borderLess", fontSize: "16px", functionCall: closeFunc }]);
      }
    } catch (error) {
      console.error("Error during login:", error);
      setOpenPopup(true);
      SetPopupTitle("Login Failed");
      SetPopupContent("Invalid credentials, please try again.");
    }
  };

  const closeFunc = () => {
    setOpenPopup(false);
    navigate("/plumberDetails");
  };

  return (
    <Grid
      container
      className="login_container"
      style={{
        backgroundImage: `url(${loginimage})`,
        height: "100vh",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Grid
        item
        xs={10}
        sm={6}
        md={4}
        sx={{
          background: "rgba(255, 255, 255, 0.9)",
          padding: "2rem",
          borderRadius: "10px",
          boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
          textAlign: "center",
        }}
      >
        <Typography variant="h6" sx={{ fontWeight: "600", color: "#0D5C75", marginBottom: "1rem" }}>
          Login / Sign Up to Continue
        </Typography>

        {isHidden ? (
          <>
            <TextField
              id="email"
              label="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              fullWidth
              size="small"
              margin="dense"
              InputLabelProps={{ style: { color: "#0D5C75", fontSize: "95%" } }}
            />
            <TextField
              id="password"
              label="Password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              fullWidth
              size="small"
              margin="dense"
              InputLabelProps={{ style: { color: "#0D5C75", fontSize: "95%" } }}
            />
          </>
        ) : (
          <>
            <Typography sx={{ fontSize: "0.9rem", color: "#0D5C75", marginBottom: "0.5rem" }}>
              Enter the verification code (OTP) sent to your mobile number.
            </Typography>
            <TextField
              value={otp}
              fullWidth
              size="small"
              margin="dense"
              onChange={(e) => setOtp(e.target.value)}
            />
            <div style={{ display: "flex", justifyContent: "space-between", marginTop: "0.5rem" }}>
              <Link href="#">Resend <span style={{ fontWeight: "bold" }}>OTP</span></Link>
              <Typography>00:05</Typography>
            </div>
          </>
        )}

        <Button
          color="green"
          name={isHidden ? "Login" : "Confirm OTP"}
          onClick={isHidden ? handleLogin : closeFunc}
          style={{ marginTop: "1rem", width: "100%" }}
        />
      </Grid>

      <DialogComp openPopup={openPopup} popuptitle={popuptitle} popupContent={popupContent} buttonValue={buttonArr} />
    </Grid>
  );
}

export default Login;
